export interface CustomerServiceOrderFiltersType {
    trackingNumbers?: string;
    recipientPhone?: string;
}

export const CustomerServiceParcelInitialValue: CustomerServiceOrderFiltersType = {
    trackingNumbers: undefined,
    recipientPhone: undefined,
};

